module.exports = __webpack_public_path__ + "media/images/trash_can-ed12afdc6296ff5d975d79ae4c3ca765.png";